import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SsoMappingRulesBannerResponse } from '@layout/sso-mapping-rules-banner/models/sso-mapping-rules-banner-response';

@Injectable({
  providedIn: 'root',
})
export class SsoMappingRulesBannerService {
  private readonly http = inject(HttpClient);

  getBannerVisibility(): Observable<SsoMappingRulesBannerResponse> {
    const url = 'api/v1/sso/mapping-rules/banner/acknowledged';

    return this.http.get<SsoMappingRulesBannerResponse>(environment.portalApiUrl + url);
  }

  acknowledgeBanner(): Observable<void> {
    const url = 'api/v1/sso/mapping-rules/banner/acknowledged';

    return this.http.post<void>(environment.portalApiUrl + url, null);
  }
}
